import { Directive, ElementRef, AfterViewInit, Input, Renderer2 } from "@angular/core";
import * as _ from "lodash";

@Directive({
  selector: "[appHasPermission]",
})
export class HasPermissionDirective implements AfterViewInit {
  @Input("appHasPermission") permissionUrlAndMethod: any;
  
  constructor(private elemntRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    const resourcesValue = JSON.parse(localStorage.getItem("resources"));
    let allChildResourcesArray = [];

    _.forEach(resourcesValue, function (data) {
      allChildResourcesArray = _.concat(allChildResourcesArray, data.ChildResources);
    });

    // ✅ Handle case where `permissionUrlAndMethod` is an **array** of permissions
    const permissionsArray = Array.isArray(this.permissionUrlAndMethod) ? this.permissionUrlAndMethod : [this.permissionUrlAndMethod];

    const hasValidPermission = permissionsArray.some((permission) => {
      if (!_.isEmpty(permission.Url) && !_.isEmpty(permission.method)) {
        const findElementByURLandMethod = _.find(allChildResourcesArray, function (o) {
          return o.Url == permission.Url && o.MethodType == permission.method;
        });
        return !_.isNil(findElementByURLandMethod);
      } else {
        const findElementByMenu = _.find(resourcesValue, function (o) {
          return o.Menu == permission.menu;
        });
        return !_.isNil(findElementByMenu);
      }
    });

    // ✅ Hide element if **no valid permission** found
    if (!hasValidPermission) {
      this.elemntRef.nativeElement.outerHTML = "";
    }
  }
}
